import { Component, OnInit, Input, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';
declare var $;

@Component({
  selector: 'app-sw-cascader-select-box',
  templateUrl: './sw-cascader-select-box.component.html',
  styleUrls: ['./sw-cascader-select-box.component.css']
})
export class SwCascaderSelectBoxComponent implements OnInit {

  constructor(private el: ElementRef) { }

  ngOnInit() {
  }

  @Input() ids:any;
  @Input() keySelected:any;

  @Input() elem:any;

  @Input() dropdown: boolean = true;

  @Input() height: string = '150px';

  @Input() width: string = '180px';

  @Input() datas:any=[]

  @Input() disabledNodeId:string = "";
  
  @Input() readonlyNodeId:any[] = []  

  @Input() readonlySelfId:any[] = []  
  
  @Input() isOneOpen:boolean = false

  /**
   * 最底层节点带复选框
   */
  @Input() selectChildren: boolean = false;

  /**
   * 所有节点带复选框
   */
  @Input() allCanCheck: boolean = false;

  /**
   * 复选功能回显的id
   */
  @Input() multiNodeIds: any[] = [];

  /**
   * 单选选择任意一级选项
   */
  @Input() radio: boolean = false

  /**
   * 异步加载的请求地址，没有则为同步加载
   */
  @Input() asyncUrl: string;

  /**
   * 选中数据
   */
  @Output() changeClick = new EventEmitter();
  @Output() closeSelect = new EventEmitter();

  ngAfterViewInit(): void {
    
    let postion = this.elem.nativeElement.getBoundingClientRect()
    this.el.nativeElement.style.position = 'fixed';
    this.el.nativeElement.style.zIndex = 9990;
    this.el.nativeElement.style.left = postion.left + 'px';
    this.el.nativeElement.style.width = postion.width + 'px';

    let height = this.height.split('px')[0]
    let clientHeight = document.documentElement.clientHeight || document.body.clientHeight
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    let heightAndTop = clientHeight + scrollTop
    if((heightAndTop-postion.bottom)<parseInt(height) ){
      //在输入框上方显示
      this.el.nativeElement.style.top = postion.top - parseInt(height) + 'px';
    }else {
      //在输入框下方显示
      this.el.nativeElement.style.top = postion.bottom + 'px';
    }

    this.myModalBodyScroll()  //监听 myModalBody 盒子的滚动条事件
    this.myWrapContScroll()  //监听 myWrapCont 盒子的滚动条事件
  }

  ngOnDestroy(): void {
    this.myModalBodyRmScroll()  //移除 myModalBody 盒子的滚动条事件
    this.myWrapContRmScroll()  //移除 myWrapCont 盒子的滚动条事件
  }

  /**
   * 选择事件
   * @ignore
   * @param node 
   */
  voted(node){
    if(this.allCanCheck || this.selectChildren){
      //如果是多选，就算修改了多选结果，也不要关闭下拉框
      this.changeClick.emit(node)
    } else {
      //如果是单选，改变了选中结果之后就直接关闭下拉框
      this.dropdown = false;//关闭下拉框
      this.closeSelect.emit(node)
    }
    return false; //阻止事件冒泡而关闭下拉框
  }

  @HostListener('document:mousewheel', ['$event']) onmousewheel(event) {
    //鉴定全屏键盘事件 如果是鼠标滚轮滚动触发
    //如果鼠标滚轮滚动的同时,ctrl键按下了,说明是缩放屏幕,就让下拉框消失;否则只是在下拉框中进行下拉操作
    if(this.mouseo){  
      this.closeSelect.emit(false)
    }
  } 

  @HostListener('document:scroll', ['$event'])
  windowScrolled($event) {
    this.closeSelect.emit(false)
  }
  
  //屏幕缩放时
  // @HostListener('window:resize', ['$event']) resize(event) {
  //   /* //屏幕缩放时,下拉框消失,否则下拉框
  //   this.closeSelect.emit(false) */
  //   //屏幕缩放时,重新设置下拉框的位置及宽度
  //   let postion = this.elem.nativeElement.getBoundingClientRect()
  //   this.el.nativeElement.style.top = postion.bottom + 'px';
  //   this.el.nativeElement.style.left = postion.left + 'px';
  //   this.el.nativeElement.style.width = postion.width + 'px';
  // }
  close(e) {
    setTimeout(() => {
      this.closeSelect.emit(false)
    }, 200);
  }

  mouseo:boolean = true;
  mouseoverEvent(){
    this.mouseo = false;
  }
  mouseoutEvent(){
    this.mouseo = true;
  }

  //监听 myWrapCont 盒子的滚动条事件,滚动就让日期控件消失
  myWrapContScroll(){
    let _scroll = $("#myWrapCont")[0]
    if(_scroll) {
      _scroll.addEventListener('scroll',()=>{
        this.closeSelect.emit(false)
      })
    }
  }

  //页面销毁时,移除此事件
  myWrapContRmScroll(){
    let _scroll = $("#myWrapCont")[0]
    if(_scroll){
      _scroll.removeEventListener('scroll',this.myWrapContScroll)
    }
  }

  //监听 myModalBody 盒子的滚动条事件,滚动就让日期控件消失
  myModalBodyScroll(){
    let _scroll = $("#myModalBody")[0]
    if(_scroll) {
      _scroll.addEventListener('scroll',()=>{
        this.closeSelect.emit(false)
      })
    }
  }

  //页面销毁时,移除此事件
  myModalBodyRmScroll(){
    let _scroll = $("#myModalBody")[0]
    if(_scroll){
      _scroll.removeEventListener('scroll',this.myModalBodyScroll)
    }
  }

}
